import { useState } from "react";
import { LOGO_URL } from "@/lib/branding";
import { cn } from "@/lib/utils";

/**
 * Logo — resilient <img> wrapper for the Apostolic Carmel emblem.
 *
 * If the image ever fails to load (bad network, CDN hiccup, ad-blocker matching
 * the emergent asset domain, etc.), it gracefully falls back to a "CS" monogram
 * so the school branding never looks broken.
 *
 * Sizes are Tailwind-friendly (pass className with w-XX h-XX).
 */
export default function Logo({ className = "w-14 h-14", framed = true, testId = "logo", alt = "Apostolic Carmel" }) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        data-testid={`${testId}-fallback`}
        className={cn(
          "flex items-center justify-center font-serif font-bold text-carmel-gold",
          framed && "bg-white ring-1 ring-carmel-gold/40 rounded-md",
          className
        )}
      >
        <span className="text-[42%] leading-none">CS</span>
      </div>
    );
  }

  return (
    <img
      src={LOGO_URL}
      alt={alt}
      loading="eager"
      decoding="async"
      data-testid={testId}
      onError={() => setErrored(true)}
      className={cn("object-contain", framed && "bg-white rounded-md ring-1 ring-carmel-gold/30 p-1", className)}
    />
  );
}
